import { debugLog, debugError } from "./debug";

const MINIAPP_ENDPOINT = (process.env.REACT_APP_MINIAPP_ENDPOINT || "").trim();

const SCOPE = "plans";

const formatBirr = (amount) =>
  Number(amount).toLocaleString("en-US", { maximumFractionDigits: 2 });

// /plans shape → the shape the paywall renders. Only plans of a
// month or longer get the "≈ per month" line.
const toPlan = ({ id, name, price, duration }) => ({
  id: String(id),
  time: name,
  price: formatBirr(price),
  perMonth:
    duration >= 28
      ? formatBirr(Math.round((price * 30) / duration))
      : undefined,
});

/**
 * The public plans the paywall offers. There is no built-in list: whatever
 * the backend returns is what the user can buy. Sent without a token on
 * purpose — with one, /plans also returns hidden plans assigned to the user.
 * Rejects on a network error or a response without a `plans` array.
 */
export const fetchPlans = async () => {
  const res = await fetch(`${MINIAPP_ENDPOINT}/api/plans`, {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  });
  const json = await res.json().catch(() => null);
  debugLog(SCOPE, "plans", { status: res.status, json });

  if (!res.ok || !json || !Array.isArray(json.plans)) {
    debugError(SCOPE, "plans unusable response", {
      status: res.status,
      json,
    });
    throw new Error(`plans responded ${res.status}`);
  }

  return json.plans
    .filter((p) => p && p.id != null && Number.isFinite(Number(p.price)))
    .map(toPlan);
};
